import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { OrderProduct } from "../OrderProduct.js";
import { ProductOption, productOptionKeyMap } from "../ProductOption.js";
import { calculatePriceForProductOption } from "./calculatePriceForProductOption.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";

export function getPriceOfOrderProduct({
	product,
	quantity,
	options,
}: Pick<OrderProduct, "product" | "quantity" | "options">): {
	withTax: number;
	withoutTax: number;
	unitWithTax: number;
	unitWithoutTax: number;
} {
	const baseWithTax = product.price.withTax;

	const priceOfOptions = options
		? Object.values(ProductOption).reduce((acc, option) => {
				const optionKey = productOptionKeyMap[option];
				if (!(optionKey in options)) {
					return acc;
				}

				const value = options[optionKey];

				return acc + calculatePriceForProductOption(baseWithTax, option, value);
			}, 0)
		: 0;

	const unitPriceWithTax = baseWithTax + priceOfOptions;
	const totalWithTax = unitPriceWithTax * quantity;
	return {
		withTax: roundToPlaces(totalWithTax, 2),
		withoutTax: calculatePriceWithoutTax(totalWithTax, product.price.taxLevel),
		unitWithTax: roundToPlaces(unitPriceWithTax, 2),
		unitWithoutTax: calculatePriceWithoutTax(unitPriceWithTax, product.price.taxLevel),
	};
}
